import { useStore } from 'vuex'
import supportTypeEnum from '../supportTypeEnum'

export default function () {
    const store = useStore()
    const donationFor = store.state.donation.donationFor
    const donationTeam = store.state.donation.donationTeam

    return donationFor === supportTypeEnum.STAFET || donationTeam !== ''
}
